import CaptureLicenseFront from "@/modules/license/pages/CaptureLicenseFront.vue";
import CaptureLicenseBack from "@/modules/license/pages/CaptureLicenseBack.vue";
export default [
  {
    path: "/document/license/front",
    name: "catureLicenseFront",
    component: CaptureLicenseFront,
  },
  {
    path: "/document/license/back",
    name: "captureLicenseBack",
    component: CaptureLicenseBack,
  },
];
